import { radius } from '@flowio/design-tokens';
var borderRadius = {
  image: radius.medium,
  banner: radius.medium,
  button: {
    small: radius.medium,
    medium: radius.medium,
    large: radius.medium
  },
  checkbox: 3
};
export default borderRadius;